import {
  GET_CONTEXT_HUB,
  GET_CONTEXT_HUB_SUCCESS,
  GET_CONTEXT_HUB_FAILURE,
  normalizeContextHubEvents,
} from '../actions/contextHub';

// fetchedEvents: Successfully fetched events that won't be re-requested
// inFlightEvents: Events currently being fetched (prevents duplicate API calls)
// failedEvents: Events that failed; use fetchedEvents to check if partial data is available

const INITIAL_STATE = {
  loading: false,
  fetchedEvents: [],
  inFlightEvents: [],
  failedEvents: [],
};

const removeInFlightEvents = (existingInflightEvents, eventsToRemove) => (
  existingInflightEvents.filter(event => !eventsToRemove.includes(event))
);
export default function contextHubReducer(state = INITIAL_STATE, action) {
  const requestedEvents = normalizeContextHubEvents(action.events || []);
  const fetchedEvents = state.fetchedEvents || [];
  const inFlightEvents = state.inFlightEvents || [];
  const failedEvents = state.failedEvents || [];

  switch (action.type) {
    case GET_CONTEXT_HUB: {
      return {
        ...state,
        inFlightEvents: [...new Set([...inFlightEvents, ...requestedEvents])],
        loading: true,
      };
    }
    case GET_CONTEXT_HUB_SUCCESS: {
      const remainingInFlightEvents = removeInFlightEvents(inFlightEvents, requestedEvents);
      return {
        ...state,
        fetchedEvents: [...new Set([...fetchedEvents, ...requestedEvents])],
        inFlightEvents: remainingInFlightEvents,
        failedEvents: failedEvents.filter(event => !requestedEvents.includes(event)),
        loading: remainingInFlightEvents.length > 0,
        errorContexts: undefined,
        contextHub: {
          ...state.contextHub,
          ...action.payload.accountContext,
          ...action.payload.indicatorContext,
        },
      };
    }
    case GET_CONTEXT_HUB_FAILURE: {
      const remainingInFlightEvents = removeInFlightEvents(inFlightEvents, requestedEvents);
      return {
        ...state,
        inFlightEvents: remainingInFlightEvents,
        failedEvents: [...new Set([...failedEvents, ...requestedEvents])],
        loading: remainingInFlightEvents.length > 0,
        errorContexts: action.payload && action.payload.errorContexts,
      };
    }
    default:
      return state;
  }
}
